module.exports = __webpack_public_path__ + "static/media/logo_foot.ee67791b.png";